export default "__VITE_ASSET__zaJ25B86__"